import styled from 'styled-components';
import { themeGet, space, SpaceProps } from 'styled-system';

export type ErrorMessageProps = SpaceProps;
export const ErrorMessage = styled.div<ErrorMessageProps>`
  margin-top: 8px;
  color: ${themeGet('colors.error')};
  font-size: 12px;
  ${space};
`;
